import advertising from './advertising';
import branches from './branches';
import filters from './filters';
import locations from './locations';
import metadata from './metadata';
import productPopupInfo from './productPopupInfo';
import ratings from './ratings';
import reviews from './reviews';
import services from './services';
import sitesettings from './sitesettings';
import user from './user';

export const reducers = {
  sitesettings,
  metadata,
  user,
  locations,
  ratings,
  services,
  advertising,
  filters,
  reviews,
  branches,
  productPopupInfo,
};
